import { render } from "./CandidateComponent.vue?vue&type=template&id=1ad508e4&scoped=true"
import script from "./CandidateComponent.vue?vue&type=script&lang=js"
export * from "./CandidateComponent.vue?vue&type=script&lang=js"

import "./CandidateComponent.vue?vue&type=style&index=0&id=1ad508e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad508e4"]])

export default __exports__